
import restService from "../rest-service/RestService";
import { ITagRegisterInfo } from "../properties-data-service/Models";
import { IMasterIdentifier, IMasterIdentifierEx, IRuntimeStatisticsExportRestQueryParams, IRuntimeStatisticsModel, ITagHistory, ITagMasterIdentifier } from "./Models";
import { ApplicationMimeTypesEnum } from "../../common/enums/ApplicationMimeTypesEnum";
import { ISortParameters } from "../../common/models/ISortParameters";

interface IBeginAndEndDateGetParams {
    beginDate?: string;
    endDate?: string;
    limitRowCount?: number
}

interface IQueryParams {
    groupID: number;
}

interface ITagHistoryExportRestQueryParams {
    notificationKey: string;
    mimeType: ApplicationMimeTypesEnum;
    sortParameters: ISortParameters;
    //sortAscending: boolean;
    //sortColumnIndex: number;
    beginDate?: Date;
    endDate?: Date;
}

const TagDataService = {

    getTagHistory: async function (contextGroupID: number, tagID: number, beginDate?: Date, endDate?: Date, maxRowCount?: number,
        abortSignal?: AbortSignal): Promise<ITagHistory> {

        const queryParams: IBeginAndEndDateGetParams =
        {
            beginDate: beginDate?.toISOString(),
            endDate: endDate?.toISOString(),
            limitRowCount: beginDate ? maxRowCount : undefined
        };

        const path =`/groups/${contextGroupID}/tags/${tagID}/tagdetails/taghistory`;
        const response = await restService.get<ITagHistory, IBeginAndEndDateGetParams>(path, abortSignal, queryParams);
        return response.data;
    },
    saveTagRegister: async function(contextGroupID: number, registerInfo: ITagRegisterInfo): Promise<void> {
        const path =`/groups/${contextGroupID}/tags/register`;
        const response = await restService.post<ITagRegisterInfo, void>(path, registerInfo);
        return response.data;
    },
    getMasterIdentifier: async function(contextGroupID: number, identifier: string, abortSignal?: AbortSignal): Promise<IMasterIdentifier | undefined> {

        const queryParams: IQueryParams =
        {
            groupID: contextGroupID
        };

        const path =`/masteridentifiers/${identifier}`;
        const response = await restService.get<IMasterIdentifier | string | undefined, IQueryParams>(path, abortSignal, queryParams);
        return response.data === '' ? undefined : response.data as (IMasterIdentifier | undefined);        
    },
    getRelatedTagMasterIdentifiers: async function(contextGroupID: number, identifier: string, abortSignal?: AbortSignal): Promise<Array<IMasterIdentifierEx>> {

        const queryParams: IQueryParams & { identifier: string } =
        {
            groupID: contextGroupID,
            identifier: identifier
        };

        const path ="/masteridentifiers";
        const response = await restService.get<Array<IMasterIdentifierEx>, IQueryParams & { identifier: string }>(path, abortSignal, queryParams);
        return response.data;
    },
    updateTagMasterIdentifiers: async function(contextGroupID: number, tagIdentifiers: Array<ITagMasterIdentifier>, abortSignal?: AbortSignal): Promise<void> {
        const path =`/groups/${contextGroupID}/tags/masteridentifiers`;
        const response = await restService.post<Array<ITagMasterIdentifier>, void>(path, tagIdentifiers, abortSignal);
        return response.data;
    },
    exportTagHistory: async function (notificationKey: string, 
        contextGroupID: number, 
        tagID: number, 
        mimeType: ApplicationMimeTypesEnum,
        sortParameters: ISortParameters, 
        beginDate?: Date, 
        endDate?: Date): Promise<void> {

        const data: ITagHistoryExportRestQueryParams = {

            notificationKey: notificationKey,
            mimeType: mimeType,
            sortParameters: sortParameters,
            beginDate: beginDate,
            endDate: endDate
        };
           
        const path =`/groups/${contextGroupID}/tags/${tagID}/taghistory/export`;
        const response = await restService.post<ITagHistoryExportRestQueryParams, void>(path, data);
        return response.data;
    },
    exportAlarmHistory: async function (notificationKey: string, 
        contextGroupID: number, 
        tagID: number, 
        mimeType: ApplicationMimeTypesEnum,
        sortParameters: ISortParameters, 
        beginDate?: Date, 
        endDate?: Date): Promise<void> {

        const data: ITagHistoryExportRestQueryParams = {

            notificationKey: notificationKey,
            mimeType: mimeType,
            sortParameters: sortParameters,
            beginDate: beginDate,
            endDate: endDate
        };
           
        const path =`/groups/${contextGroupID}/tags/${tagID}/tagalarmhistory/export`;
        const response = await restService.post<ITagHistoryExportRestQueryParams, void>(path, data);
        return response.data;
    },
    exportControlHistory: async function (notificationKey: string, 
        contextGroupID: number, 
        tagID: number, 
        mimeType: ApplicationMimeTypesEnum,
        sortParameters: ISortParameters, 
        beginDate?: Date, 
        endDate?: Date): Promise<void> {

        const data: ITagHistoryExportRestQueryParams = {

            notificationKey: notificationKey,
            mimeType: mimeType,
            sortParameters: sortParameters,
            beginDate: beginDate,
            endDate: endDate
        };
           
        const path =`/groups/${contextGroupID}/tags/${tagID}/controlhistory/export`;
        const response = await restService.post<ITagHistoryExportRestQueryParams, void>(path, data);
        return response.data;
    },


    getCurrentRunTimeStatistics: async function(groupID: number, tagID: number, abortSignal?: AbortSignal): Promise<IRuntimeStatisticsModel> {
        const path = `/groups/${groupID}/tags/${tagID}/tagdetails/currentmonthruntimestatistics`;
        const response = await restService.get<IRuntimeStatisticsModel>(path, abortSignal);
        return response.data;
    },

    getRunTimeStatistics: async function(groupID: number, tagID: number, beginDate?: Date, endDate?: Date, abortSignal?: AbortSignal): Promise<IRuntimeStatisticsModel> {

        const path = `/groups/${groupID}/tags/${tagID}/tagdetails/runtimestatistics`;

        const getQueryParams: IBeginAndEndDateGetParams =
        {
            beginDate: beginDate?.toISOString(),
            endDate: endDate?.toISOString(),
        };

        const response = await restService.get<IRuntimeStatisticsModel, IBeginAndEndDateGetParams>(path, abortSignal, getQueryParams);

        return response.data;
    },

    exportRunTimeStatistics: async function(notificationKey: string, groupID: number, tagID: number, mimeType: ApplicationMimeTypesEnum,  beginDate?: Date, endDate?: Date): Promise<void> {
        
        const path = `/groups/${groupID}/tags/${tagID}/tagdetails/runtimestatistics/export`;
        const queryParams: IRuntimeStatisticsExportRestQueryParams = {
            notificationKey: notificationKey,
            mimeType: mimeType,
            beginDate: beginDate,
            endDate: endDate
        }

        await restService.post(path, queryParams);

        // await restService.post(path, return this._restService.post(path, <IRuntimeStatisticsExportRestQueryParams> {
        //     notificationKey: notificationKey,
        //     mimeType: mimeType,
        //     beginDate: beginDate,
        //     endDate: endDate
        // }).then((data) => {
        //     return data.entity;
        // });
    }








    // public exportTagHistoryData(notificationKey: string, groupID: number, tagID: number, mimeType: Enums.ApplicationMimeTypesEnum, sortParameters: Models.ISortParameters, beginDate?: moment.Moment, endDate?: moment.Moment) //,
    // //sortAscending: boolean = true,
    // //sortColumnIndex: number = 0)
    // : Services.RestPromise<any> {



    //     var path: string = [
    //         "groups",
    //         groupID,
    //         "tags",
    //         tagID,
    //         "tagdetails",
    //         "taghistory",
    //         "export"
    //     ].join("/");

    //     return this._restService.post(path, <Models.ITagHistoryExportRestQueryParams> {
    //         notificationKey: notificationKey,
    //         mimeType: mimeType,
    //         sortParameters: sortParameters,
    //         beginDate: beginDate,
    //         endDate: endDate
    //     }).then((data) => {
    //         return data.entity;
    //     });
    // }

    // public exportTagAlarmHistoryData(notificationKey: string, groupID: number, tagID: number, mimeType: Enums.ApplicationMimeTypesEnum, sortParameters: Models.ISortParameters, beginDate?: moment.Moment, endDate?: moment.Moment) //,
    // //sortAscending: boolean = true,
    // //sortColumnIndex: number = 0)
    // : Services.RestPromise<any> {
   
    //     var path: string = [
    //         "groups",
    //         groupID,
    //         "tags",
    //         tagID,
    //         "tagdetails",
    //         "tagalarmhistory",
    //         "export"
    //     ].join("/");
   
    //     return this._restService.post(path, <Models.ITagHistoryExportRestQueryParams> {
    //         notificationKey: notificationKey,
    //         mimeType: mimeType,
    //         //            sortAscending: sortAscending,
    //         //            sortColumnIndex: sortColumnIndex
    //         sortParameters: sortParameters,
    //         beginDate: beginDate,
    //         endDate: endDate
    //     }).then((data) => {
    //         return data.entity;
    //     });
    // }

    // public exportTagControlHistoryData(notificationKey: string, groupID: number, tagID: number, mimeType: Enums.ApplicationMimeTypesEnum, sortParameters: Models.ISortParameters, beginDate?: moment.Moment, endDate?: moment.Moment) //,
    // //sortAscending: boolean = true,
    // //sortColumnIndex: number = 0)
    // : Services.RestPromise<any> {
   
    //     var path: string = [
    //         "groups",
    //         groupID,
    //         "tags",
    //         tagID,
    //         "tagdetails",
    //         "controlhistory",
    //         "export"
    //     ].join("/");
   
    //     return this._restService.post(path, <Models.ITagHistoryExportRestQueryParams> {
    //         notificationKey: notificationKey,
    //         mimeType: mimeType,
    //         //            sortAscending: sortAscending,
    //         //            sortColumnIndex: sortColumnIndex
    //         sortParameters: sortParameters,
    //         beginDate: beginDate,
    //         endDate: endDate
    //     }).then((data) => {
    //         return data.entity;
    //     });
    // }

};

export default TagDataService;